import React from 'react';

const DeepDiveView = ({ state }) => {
  const {
    selectedTrend,
    savedResearch,
    openMaiaWithContext,
    setWorkflowStep,
  } = state;

  return (
    <div style={{ padding: '32px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 24, fontWeight: '600', color: '#f3f4f6' }}>Deep Dive: {selectedTrend.signal}</h2>
          <p style={{ margin: '8px 0 0', color: '#9ca3af', fontSize: 14 }}>
            Stacked LLM analysis {'\u2022'} External signals validated
          </p>
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          <button
            onClick={openMaiaWithContext}
            style={{
              backgroundColor: 'transparent',
              color: '#f59e0b',
              border: '2px solid #f59e0b',
              padding: '12px 24px',
              borderRadius: 8,
              fontWeight: '600',
              cursor: 'pointer',
              fontSize: 14
            }}
          >
            Conduct Deep Research
          </button>
          <button
            onClick={() => setWorkflowStep(2)}
            style={{
              backgroundColor: '#6366f1',
              color: 'white',
              border: 'none',
              padding: '12px 24px',
              borderRadius: 8,
              fontWeight: '600',
              cursor: 'pointer',
              fontSize: 14
            }}
          >
            Proceed to Content Match {'\u2192'}
          </button>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
        <div style={{ backgroundColor: '#1e1e32', borderRadius: 12, padding: 24, border: '1px solid #2d2d44' }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: '600', color: '#f3f4f6' }}>Analysis Summary</h3>
          <p style={{ margin: 0, color: '#d1d5db', fontSize: 14, lineHeight: 1.7 }}>
            {selectedTrend.deepDive.summary}
          </p>
        </div>

        <div style={{ backgroundColor: '#1e1e32', borderRadius: 12, padding: 24, border: '1px solid #2d2d44' }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: '600', color: '#f3f4f6' }}>External Signals</h3>
          <div style={{ display: 'grid', gap: 12 }}>
            {Object.entries(selectedTrend.externalSignals).map(([key, value]) => (
              <div key={key} style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#9ca3af', fontSize: 13, textTransform: 'capitalize' }}>
                  {key.replace(/([A-Z])/g, ' $1').trim()}
                </span>
                <span style={{ color: '#f3f4f6', fontSize: 13, fontWeight: '500' }}>{value}</span>
              </div>
            ))}
          </div>
        </div>

        <div style={{ backgroundColor: '#1e1e32', borderRadius: 12, padding: 24, border: '1px solid #2d2d44' }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: '600', color: '#f3f4f6' }}>Audience Potential</h3>
          <div style={{ display: 'grid', gap: 12 }}>
            <div>
              <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4, textTransform: 'uppercase' }}>Current Overlap</div>
              <div style={{ fontSize: 14, color: '#f3f4f6' }}>{selectedTrend.deepDive.audienceOverlap}</div>
            </div>
            <div>
              <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4, textTransform: 'uppercase' }}>Growth Potential</div>
              <div style={{ fontSize: 14, color: '#10b981' }}>{selectedTrend.deepDive.growthPotential}</div>
            </div>
            <div>
              <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4, textTransform: 'uppercase' }}>Consumer Intent</div>
              <div style={{ fontSize: 14, color: '#f3f4f6' }}>{selectedTrend.deepDive.consumerIntent}</div>
            </div>
          </div>
        </div>

        <div style={{ backgroundColor: '#1e1e32', borderRadius: 12, padding: 24, border: '1px solid #2d2d44' }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: '600', color: '#f3f4f6' }}>Competitive Landscape</h3>
          <div style={{ display: 'grid', gap: 12 }}>
            <div>
              <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4, textTransform: 'uppercase' }}>Competitor Coverage</div>
              <div style={{ fontSize: 14, color: '#f59e0b' }}>{selectedTrend.deepDive.competitorCoverage}</div>
            </div>
            <div style={{ marginTop: 8, padding: 12, backgroundColor: '#252540', borderRadius: 8 }}>
              <div style={{ fontSize: 12, color: '#9ca3af', marginBottom: 4 }}>Strategist Note</div>
              <div style={{ fontSize: 13, color: '#d1d5db', fontStyle: 'italic' }}>
                Window of opportunity exists for authoritative content before category saturation
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Research History Section */}
      {savedResearch.length > 0 && (
        <div style={{ marginTop: 24 }}>
          <div style={{
            backgroundColor: '#1e1e32',
            borderRadius: 12,
            padding: 24,
            border: '1px solid #2d2d44',
            borderLeft: '4px solid #f59e0b'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: '600', color: '#f3f4f6' }}>
                Saved Research ({savedResearch.length})
              </h3>
              <span style={{ fontSize: 12, color: '#6b7280' }}>Attached to this opportunity</span>
            </div>
            <div style={{ display: 'grid', gap: 12 }}>
              {savedResearch.map(research => (
                <div key={research.id} style={{
                  padding: 16,
                  backgroundColor: '#252540',
                  borderRadius: 8
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                    <div style={{ display: 'flex', gap: 8 }}>
                      {research.agents.map((agent, idx) => (
                        <span key={idx} style={{
                          padding: '2px 8px',
                          backgroundColor: '#374151',
                          borderRadius: 4,
                          fontSize: 11,
                          color: '#9ca3af'
                        }}>
                          {agent}
                        </span>
                      ))}
                    </div>
                    <span style={{ fontSize: 11, color: '#6b7280' }}>{research.timestamp}</span>
                  </div>
                  <div style={{ fontSize: 13, color: '#d1d5db', marginBottom: 8 }}>
                    <strong>Query:</strong> {research.query}
                  </div>
                  <div style={{ fontSize: 13, color: '#9ca3af', lineHeight: 1.6 }}>
                    {research.insight.substring(0, 300)}...
                  </div>
                  <div style={{ marginTop: 8, fontSize: 11, color: '#6b7280' }}>
                    Conducted during: {research.workflowStep}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeepDiveView;
